import { render, staticRenderFns } from "./ChartPrice.vue?vue&type=template&id=0b1a14bc"
import script from "./ChartPrice.vue?vue&type=script&lang=js"
export * from "./ChartPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports